import React from "react";
import styled from "styled-components";
import Paragraph from "../atoms/Paragraph";
import { Trans } from "react-i18next";
const StyledParagraphFirst = styled(Paragraph) `
  margin-bottom: 10px;
  color: #6b6b6b;

  strong {
    color: ${props => props.theme.primary};
  }
`;
const StyledAnchor = styled.a `
  color: ${props => props.theme.primary};
  text-decoration: underline;
`;
const RequestNotAvailable = () => {
    return (React.createElement(StyledParagraphFirst, null,
        React.createElement(Trans, { i18nKey: "dossier:arrangement.request_not_available", components: {
                anchor: React.createElement(StyledAnchor, { href: "/contact" }),
            } })));
};
export default RequestNotAvailable;
